/* AUTO-SYNCED from PsyKit.io/lib/checkin-types.ts — DO NOT EDIT. Regenerate with `npm run sync`. */
export interface PreCheckinData {
  goal: string;
  emotions: string[];
  distress: number | null;
  capability: number | null;
  note: string;
}

export interface PostCheckinData {
  emotions: string[];
  distress: number | null;
  capability: number | null;
  note: string;
}

/** Which check-in form the therapist has pushed to the client (null = none). */
export type CheckinActive = "pre" | "post" | null;

/**
 * Live, collaboratively-edited check-in answers broadcast between the therapist
 * and client over Socket.IO (the `checkin_data` event). Whichever side edits a
 * field, the other mirrors it — same idea as the bilateral `frame` payload but
 * at human-typing speed. `goal` is only meaningful for the pre check-in.
 */
export interface CheckinLiveData {
  phase: "pre" | "post";
  goal: string;
  emotions: string[];
  distress: number | null;
  capability: number | null;
  note: string;
}

/** A blank live-data payload for a given phase. */
export function emptyCheckinData(phase: "pre" | "post"): CheckinLiveData {
  return { phase, goal: "", emotions: [], distress: null, capability: null, note: "" };
}

export interface SessionFollowup {
  id: string;
  sessionId: string;
  conductedAt: string;
  emotions: string[];
  distress: number | null;
  capability: number | null;
  note: string | null;
  createdAt: string;
}

export interface SessionCheckin {
  id: string;
  sessionId: string | null;
  sessionCode: string;
  source: "therapist" | "client";
  preGoal: string | null;
  preEmotions: string[];
  preDistress: number | null;
  preCapability: number | null;
  preNote: string | null;
  postEmotions: string[];
  postDistress: number | null;
  postCapability: number | null;
  postNote: string | null;
  createdAt: string;
}
